<template lang="">
  <div class="card">
    <div class="card-body">
      <h6 class="card-title text-secondary">
        <span class="text-blue fw-bold">Productos</span> recomendados
      </h6>
      <div class="row">
        <div
          v-for="product in fixedProducts"
          :key="product.id"
          class="col-12 col-sm-6 col-xl-4"
        >
          <product-suggestion-search :product="product" />
        </div>
      </div>
      <div class="text-center">
        <base-link
          class="text-danger fs-8 p-0"
          @click="getResults(getSeeMore())"
        >
          Ver más resultados
        </base-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ProductSuggestionSearch from "@/components/navigation/ProductSuggestionSearch.vue";
import BaseLink from "~/components/buttons/BaseLink.vue";
import { getTitleTranslate } from "@/utils/general";
import eventBus from "~/event-bus";
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";

export default {
  components: {
    ProductSuggestionSearch,
    BaseLink,
  },
  props: {
    products: {
      type: Array,
      default() {
        return [];
      },
    },
    seeMore: {
      type: String,
      default: "/",
    },
  },
  emits: ["close-suggestions"],
  data() {
    return {
      isMobileSize: useBreakpoints(breakpointsBootstrapV5).isSmallerOrEqual(
        "md",
      ),
    };
  },
  computed: {
    fixedProducts() {
      return this.isMobileSize ? this.products.slice(0, 3) : this.products;
    },
  },
  methods: {
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },

    getSeeMore() {
      return "/" + this.seeMore;
    },

    closeSuggestion() {
      eventBus.emit("close-suggestions");
    },

    getResults(path: string) {
      eventBus.emit("get-results", path);
      eventBus.emit("close-suggestions");

      this.$router.push(path).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped></style>
